<div class="yf-row center gap-6">
  <ion-icon name="card-outline" color="light" [class]="$class()"></ion-icon>
  <ion-text color="tertiary" [class]="$class()">
    {{$cost() || 0 | number: '1.2-2'}} €
  </ion-text>
</div>